import React from 'react';
import { formatCurrency } from '../../../lib/helpers/formatters';
import { INSURANCES_ALLOWED_TYPES } from '../../../App';

const TotalTr = ({ totals = {}, profileType = '' }) => {
  const {
    shareToInvoiceTotals = 0,
    panoramicaShareTotals = 0,
    adminShareTotals = 0,
    netTotals = 0,
    grossTotals = 0,
  } = totals;

  return (
    <tr className="summary-tr">
      {INSURANCES_ALLOWED_TYPES.includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {!['SUPPLIER_INS'].includes(profileType) && <td>-</td>}
      {!['SUPPLIER_INS'].includes(profileType) && <td>-</td>}
      {!['SUPPLIER_INS'].includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td className="txt-table-right">{formatCurrency(grossTotals)}</td>
      <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      <td className="txt-table-right">
        {formatCurrency(shareToInvoiceTotals)}
      </td>
      <td>-</td>
      <td className="txt-table-right">
        {formatCurrency(panoramicaShareTotals)}
      </td>
      <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      <td>-</td>
      {INSURANCES_ALLOWED_TYPES.includes(profileType) && <td>-</td>}
      {INSURANCES_ALLOWED_TYPES.includes(profileType) && <td>-</td>}
    </tr>
  );
};

export default TotalTr;
